import { Model } from 'algu-domain'

import { configuratorInterface } from '../configurator-interface'

/**
 * If the both the table top and legs are made of oak, the color of the legs
 * must match the color of the top.
 */

/**
 * If both are made of oak, the swatch changes the top color and the legs color must follow.
 */
export const fixOakLegsColorOnTopColorChange = configuratorInterface.transformerBuilder.when
  .entity(Model.Top.types)
  .modified({ atFields: ['color'] })
  .causes.entity(Model.OakLegs.types)
  .violation(['oakLegsAndTopColorNotMatching'])
  .then.applySideEffect(ctx => {
    const $table = ctx.getOld$Root()
    return [
      configuratorInterface.updates.DomainEntityModification({
        entityId: $table.$legs.id,
        stateDelta: { color: ctx.update.stateDelta.color },
        updateTag: 'fixOakLegs.updateColorToMatchTop',
      }),
    ]
  })
  .build('Fix oak legs color on oak top color change')

/**
 * If the table top is changed to oak from a different material and the legs are oak, the new
 * top color must match the legs color.
 */
export const fixOakTopColorOnMaterialChange = configuratorInterface.transformerBuilder.when
  .entity(Model.Top.types)
  .modified({ atFields: ['material'] })
  .causes.entity(Model.OakLegs.types)
  .violation(['oakLegsAndTopColorNotMatching'])
  .then.overrideMatchingUpdate(ctx => {
    const $table = ctx.getOld$Root()
    if (!Model.ColorOak.is($table.$legs.color)) {
      return [ctx.update]
    }
    return [
      {
        ...ctx.update,
        stateDelta: {
          ...ctx.update.stateDelta,
          color: $table.$legs.color,
        },
      },
    ]
  })
  .build('Fix oak top color when changing top material to oak and legs are oak')
